import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import type { ChecklistStatus, MarginBand } from '../shared/checklistUtils';

interface Props {
  approvalType?: 'auto' | 'manual';
  band?: MarginBand;
  status: ChecklistStatus;
}

export default function ChecklistStatusDot({ approvalType = 'auto', band, status }: Props) {
  const colorKey = getDotColor(band, status);
  const label = band ? capitalize(band) : getDotLabel(status, approvalType);

  return (
    <Stack
      direction="row"
      spacing={0.875}
      alignItems="center"
      sx={{ color: colorKey, fontWeight: 700, whiteSpace: 'nowrap' }}
    >
      <Box
        component="span"
        sx={{
          bgcolor: colorKey,
          borderRadius: '50%',
          boxShadow: '0 0 0 2px rgba(0,0,0,0.04)',
          height: 10,
          width: 10,
        }}
      />
      <Typography variant="body2" fontWeight={700}>
        {label}
      </Typography>
    </Stack>
  );
}

function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function getDotColor(band: MarginBand | undefined, status: ChecklistStatus) {
  if (band === 'red') {
    return 'error.main';
  }
  if (band === 'green' || status === 'approved') {
    return 'success.main';
  }
  if (status === 'blocked') {
    return 'text.disabled';
  }
  return 'warning.main';
}

function getDotLabel(status: ChecklistStatus, approvalType: 'auto' | 'manual') {
  if (status === 'approved') {
    return approvalType === 'manual' ? 'Manually approved' : 'Approved';
  }
  if (status === 'blocked') {
    return 'Missing data';
  }
  if (status === 'needsApproval') {
    return 'CM approval required';
  }
  return 'Requires approval';
}
